module.exports = __webpack_public_path__ + "public/567c9fd88552950af48e50e9c0d0571f.woff";